import { render, staticRenderFns } from "./playbill.vue?vue&type=template&id=a12c4c8c&scoped=true"
import script from "./playbill.vue?vue&type=script&lang=js"
export * from "./playbill.vue?vue&type=script&lang=js"
import style0 from "./playbill.vue?vue&type=style&index=0&id=a12c4c8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12c4c8c",
  null
  
)

export default component.exports